import { BaseApiService } from './BaseApiService';
import { LoginResponse, User } from '../types';
import { LoginRequest as AuthLoginRequest } from '../types/auth';

export class AuthService extends BaseApiService {
  private static instance: AuthService;

  constructor() {
    super();
    if (AuthService.instance) {
      return AuthService.instance;
    }
    AuthService.instance = this;
  }

  async login(credentials: AuthLoginRequest): Promise<LoginResponse> {
    return this.post<LoginResponse>('/api/auth/login', credentials);
  }

  async loginWithGoogle(email: string, googleId: string, name?: string): Promise<LoginResponse> {
    return this.post<LoginResponse>('/api/auth/google', { email, googleId, name });
  }

  async register(userData: any): Promise<User> {
    return this.post<User>('/api/auth/register', userData);
  }

  async refreshToken(refreshToken: string): Promise<{ accessToken: string }> {
    return this.post<{ accessToken: string }>('/api/auth/refresh-token', {
      refreshToken,
    });
  }

  async logout(): Promise<void> {
    return this.post<void>('/api/auth/logout');
  }

  async getCurrentUser(): Promise<User> {
    return this.get<User>('/api/auth/me');
  }
}
